"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Stack = _interopRequireDefault(require("../Stack"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LogImage = function LogImage(_ref) {
  var src = _ref.src;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
    width: 80,
    height: '100%',
    justifyContent: 'center',
    borderRadius: 0.5,
    border: function border(_ref2) {
      var palette = _ref2.palette;
      return "1px solid ".concat(palette.grey['300']);
    },
    overflow: 'hidden',
    mr: 2,
    flexShrink: 0,
    "data-cy": 'LogImage',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: src,
      alt: '',
      width: '100%',
      style: {
        display: 'block'
      }
    })
  });
};
LogImage.propTypes = {};
var _default = exports["default"] = LogImage;